<template>
	<div class="email-preview-content">
		<a @click="linkTo('/email-editor')" class="btn back-to-editor">Back to Editor</a>
		<div class="raw-test">
            <div v-show="showMail">
                <table id="target-table" ref="table" style="margin:0; padding:0;" width="100%" height="100%" bgcolor="#f5f5fc">
                    <tr>
                        <td style="text-align: center;">
                            <table width="100%" border="0" cellpadding="0" cellspacing="0"
                                style="margin: 0 auto; padding: 0; font-family: Tahoma, Geneva, sans-serif; max-width: 1200px;"
                                bgcolor="#ffffff">

                                <!-- SECTIONS -->
                                <tr v-for='section in editor.content' :key='section.id'>
                                    <td :style="sectionStyle(section.id)">
                                        <!-- ROWS -->
                                        <table width="100%" border="0" cellpadding="0" cellspacing="0">
                                            <tr v-for="row in section.children">
                                                <td :style="sectionStyle(row)">
                                                    <!-- COLS -->
                                                    <div v-for="col in findOne(row).cols" :style="'width: '+col.width + '%; padding: 15px; display:inline-block;min-width: 240px;vertical-align:top'">
                                                        <!-- CHILDREN -->
                                                        <div v-for="item in col.children">
                                                            <component :is="'email-'+findChild(item).type" :details="findChild(item)"></component>
                                                        </div>
                                                        <!-- CHILDREN END -->
                                                    </div>
                                                    <!-- COLS END -->
                                                </td>
                                            </tr>
                                        </table>
                                        <!-- ROWS END-->
                                    </td>
                                </tr>
                                <!-- SECTIONS END -->

                            </table>
                        </td>
                    </tr>
                </table>
            </div>
            <h3 class="code-title">Custom CSS</h3>  
            <prism-editor class="my-editor" :value="getCSS" :highlight="highlighterCss" line-numbers @input="editCode($event, 'css')" :tabSize='4'></prism-editor>
            <h3 class="code-title">Custom JS</h3>
            <prism-editor class="my-editor" :value="getJS" :highlight="highlighterJs" line-numbers @input="editCode($event, 'js')" :tabSize='4'></prism-editor>
            <h3 class="code-title">Email source code</h3>
            <prism-editor class="my-editor" :value="getMarkup" :highlight="highlighter" line-numbers @input="editCode($event, 'markup')" :tabSize='4'></prism-editor>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import spacer from "../components/generator/Spacer.vue";
import button from "../components/generator/Button.vue";
import headline from "../components/generator/Headline.vue";
import paragraph from "../components/generator/Paragraph.vue";
import image from "../components/generator/Image.vue";
import link from "../components/generator/Link.vue";
import social from "../components/generator/Social.vue";
import menu from "../components/generator/Menu.vue";
import timer from "../components/generator/Timer.vue";
import custom from "../components/generator/Custom.vue";

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-markup';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';

export default {
	name: 'PreviewEmail',
    components: {
        emailSpacer: spacer,
        emailButton: button,
        emailHeadline: headline,
        emailParagraph: paragraph,
        emailImage: image,
        emailVideo: video,
        emailLink: link,
        emailSocial: social,
        emailMenu: menu,
        emailTimer: timer,
        emailCustom: custom,
        PrismEditor,
	},
	data() {
		return {
            rawCode: 'raw',
            showMail: false,
		}
	},
    computed: {
		...mapGetters(['email_findOne', 'email_findChild']),
        editor() {
            return this.$store.state.email.editor
        },
        getCSS() {
            return this.$store.state.email.customCode.css
        },
        getJS() {
            return this.$store.state.email.customCode.js
        },
        getMarkup() {
            return this.$store.state.email.customCode.markup
        },
    },
	methods: {
        linkTo(link){
            this.$router.replace({path: link})
        },
		sectionStyle(sectionId) {
			let findSection = this.email_findOne(sectionId);

			let basic = findSection.attributes.basic;

			var border = basic.border;
			var borderTop = border && !border.sides.top ? 'none' : false;
			var borderLeft = border && !border.sides.left ? 'none' : false;
			var borderRight = border && !border.sides.right ? 'none' : false;
			var borderBottom = border && !border.sides.bottom ? 'none' : false;

			var borderRadius = border ? 
				border.radius.leftTop+'px '+
				border.radius.topRight+'px '+
				border.radius.bottomRight+'px '+
				border.radius.bottomLeft+'px' : false;

			var margin = basic.margin ? 
				basic.margin.top+'px '+
				basic.margin.right+'px '+
				basic.margin.bottom+'px '+
				basic.margin.left+'px' : false;

			var padding = basic.padding ? 
				basic.padding.top+'px '+
				basic.padding.right+'px '+
				basic.padding.bottom+'px '+
				basic.padding.left+'px' : false;

			var obj = {
				// borderColor: this.label.bg,
				backgroundColor: basic.backgroundColor || '#ffffff',
				backgroundImage: basic.backgroundImage ? `url(${basic.backgroundImage})` : 'none',
				backgroundPosition: 'center',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				margin,
				padding,
				borderWidth: border ? basic.border.width + 'px' : 'inherit',
				borderColor:  border ? basic.border.color : 'inherit',
				borderStyle:  border ? basic.border.style : 'inherit',
				borderRadius,
				borderTop,
				borderLeft,
				borderRight,
				borderBottom,
			};
			return obj
        },
        highlighter(code) {
            return highlight(code, languages.markup);
        },
        highlighterCss(code) {
            return highlight(code, languages.css);
        },
        highlighterJs(code) {
            return highlight(code, languages.js);
        },
        editCode(ev, type) {
            this.$store.dispatch('EMAIL_SET_CUSTOM_CODE', {type, code: ev})
        },
        format(node, level) {
            var indentBefore = new Array(level++ + 1).join('  '),
                indentAfter  = new Array(level - 1).join('  '),
                textNode;
            
            for (var i = 0; i < node.children.length; i++) {
                
                textNode = document.createTextNode('\n' + indentBefore);
                node.insertBefore(textNode, node.children[i]);
                
                this.format(node.children[i], level);
                
                if (node.lastElementChild == node.children[i]) {
                    textNode = document.createTextNode('\n' + indentAfter);
                    node.appendChild(textNode);
                }
            }
            
            return node;
        },
    },    
    created() {
		console.log('Preview: ', this.editor, languages);
	},
	mounted() {
        var table = document.getElementById('target-table');
		var string = table.outerHTML;
        this.rawCode = '<!-- HTML -->\n'+ this.format(table, 0).outerHTML + '\n    ';
        this.editCode(this.rawCode, 'markup');
	},
}
</script>

<style lang="scss">
.app-email-editor {
    .raw-test {
        height: 100vh;
        overflow: auto;
    }
	.back-to-editor {
		position: fixed;
		top: 25px;
		left: 25px;
	}
	.raw-code {
		display: block;
		width: 100%;
		padding: 50px;
		background: #000;
		color: #fff;
    }
    
    /* required class */
    .my-editor {
        font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
        font-size: 14px;
        line-height: 1.5;
        padding: 5px;
        height: 25%;
        border-top: 1px solid #c5c7d2;
        border-bottom: 1px solid #c5c7d2;
        background-color: #241f2d;
    }

    /* optional class for removing the outline */
    .prism-editor__textarea:focus {
        outline: none;
    }

    .code-title {
        margin: 5px 25px;
    }
}
</style>